export default [
    {
        "error_id": "OP 04",
        "data": [
            {
                "cross_section": "37830",
                "profile": "100yr (1%)"
            },
            {
                "cross_section": "42157",
                "profile": "FW"
            },
            {
                "cross_section": "41045",
                "profile": "FW"
            },
            {
                "cross_section": "37830",
                "profile": "FW"
            }
        ]
    }
]